import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CustomAttributesService {
  constructor(
    private readonly http: HttpClient,
  ) {
  }

  public getAllCA(params: any) {
    return this.http.get<any>(environment.baseURL + '/ca', { params })
      .pipe(map(v => v.data));
  }

  public getCAnById(field_id: string) {
    const url: string = environment.baseURL + `/ca/${field_id}`;
    return this.http.get<any>(url).pipe(map(v => v.data));
  }

  public createCA(payload: any) {
    return this.http.post<any>(environment.baseURL + '/ca', payload)
      .pipe(map(v => v.data));
  }

  public updateCA(payload: any, field_id: string) {
    const url: string = environment.baseURL + `/ca/${field_id}`;
    return this.http.put<any>(url, payload)
      .pipe(map(v => v.data));
  }

  public deleteCA(field_id: string) {
    const url: string = environment.baseURL + `/ca/${field_id}`;
    return this.http.delete<any>(url).pipe(map(v => v.data));
  }

}
